import { render, staticRenderFns } from "./PaginatorItem.vue?vue&type=template&id=993b074e"
import script from "./PaginatorItem.vue?vue&type=script&lang=js"
export * from "./PaginatorItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports